import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { t } from 'i18next';
import Button from '@mui/material/Button';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'var(--bg-form)',
  border: 'var(--border-input)',
  borderRadius: '5px',
  boxShadow: 24,
  p: 4,
};

interface DeleteModalProps {
  documentId: any,
  showDelete: boolean;
  setShowDelete: any;
  refresh: any;
}

const DeleteDocs: React.FC<DeleteModalProps> = ({
  documentId,
  showDelete,
  setShowDelete,
  refresh
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => setShowDelete(false);

  const handleDeleteAndClose = async () => {
    try {
      await axios.delete(`document/${documentId}`);
      await refresh();
      handleClose();
      enqueueSnackbar('Delete successfully', { variant: 'success' });
    } catch (error: any) {
      console.error('Error', error);
      enqueueSnackbar(
        error?.response?.data?.message || 'Error deleting document',
        { variant: 'error' },
      );
    }
  }

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={showDelete}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={showDelete}>
          <Box sx={style}>
            <Typography
              id="transition-modal-title"
              variant="h6"
              component="h2"
              className="text-center">
              {t('DoYouReallyWantToDeleteThisDocument?')}
            </Typography>
            <Typography
              id="transition-modal-description"
              sx={{ mt: 2 }}
              className="flex justify-between items-center gap-4">
              <Button
                variant="contained"
                sx={{
                  padding: '5px 10px',
                  fontSize: 14,
                  width: '100%',
                  color: 'white !important'
                }}
                onClick={handleDeleteAndClose}>
                {t('Yes')}
              </Button>
              <Button
                variant="contained"
                sx={{
                  padding: '5px 10px',
                  fontSize: 14,
                  width: '100%',
                  color: 'white !important'
                }}
                onClick={handleClose}>
                {t('Cancel')}
              </Button>
            </Typography>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default DeleteDocs;
